module.exports = __webpack_public_path__ + "img/upload-icon-white.90f6571d.svg";